import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Contador de requisições em andamento para a barra de progresso global — substitui o NProgress.
 * O ProgressInterceptor chama start()/done(); a OabProgressBarComponent reage a active$.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private count = 0;
  private readonly _active = new BehaviorSubject<boolean>(false);
  readonly active$ = this._active.asObservable();

  start(): void {
    this.count++;
    if (this.count === 1) {
      this._active.next(true);
    }
  }

  done(): void {
    this.count = Math.max(0, this.count - 1);
    if (this.count === 0) {
      this._active.next(false);
    }
  }
}
